import { render, staticRenderFns } from "./Chart_landing.vue?vue&type=template&id=8a4c6a7e&scoped=true&lang=pug&"
import script from "./Chart_landing.vue?vue&type=script&lang=js&"
export * from "./Chart_landing.vue?vue&type=script&lang=js&"
import style0 from "./Chart_landing.vue?vue&type=style&index=0&id=8a4c6a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4c6a7e",
  null
  
)

export default component.exports